"use client"

import { Home, LayoutGrid, Search } from "lucide-react"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { useState } from "react"
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer"
import { cn } from "@/utilities"
import { CategorySelectDrawerContent } from "../header/category-select"
import { SearchProducts } from "../header/search-products"

export function BottomNavigation() {
  const pathname = usePathname()
  const [productsOpen, setProductsOpen] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)

  const isHomeActive = pathname === "/"
  const isProductsActive =
    pathname?.startsWith("/categorias") || pathname?.startsWith("/produtos")
  const isSearchActive = pathname?.startsWith("/search")

  return (
    <nav
      aria-label='Navegação principal'
      className='fixed inset-x-0 bottom-0 z-50 border-border border-t bg-white pb-[env(safe-area-inset-bottom)] md:hidden'
    >
      <div className='mx-auto grid max-w-6xl grid-cols-3'>
        <Link
          aria-current={isHomeActive ? "page" : undefined}
          className={cn(
            "flex flex-col items-center justify-center gap-1 py-2 text-muted-foreground text-xs transition-colors",
            isHomeActive && "text-primary"
          )}
          href='/'
        >
          <Home className='h-5 w-5' />
          <span>Principal</span>
        </Link>

        <Drawer
          direction='bottom'
          onOpenChange={setProductsOpen}
          open={productsOpen}
        >
          <DrawerTrigger asChild>
            <button
              aria-current={isProductsActive ? "page" : undefined}
              aria-haspopup='dialog'
              className={cn(
                "flex flex-col items-center justify-center gap-1 py-2 text-muted-foreground text-xs transition-colors",
                isProductsActive && "text-primary"
              )}
              type='button'
            >
              <LayoutGrid className='h-5 w-5' />
              <span>Produtos</span>
            </button>
          </DrawerTrigger>

          <DrawerContent className='h-[85vh]'>
            <DrawerHeader className='flex items-center justify-between'>
              <DrawerTitle>Produtos</DrawerTitle>
              <DrawerClose asChild>
                <button
                  aria-label='Fechar'
                  className='rounded-md px-2 py-1 text-muted-foreground hover:text-foreground'
                  type='button'
                >
                  Fechar
                </button>
              </DrawerClose>
            </DrawerHeader>

            <CategorySelectDrawerContent
              onSelect={() => setProductsOpen(false)}
            />
          </DrawerContent>
        </Drawer>

        <Drawer
          direction='bottom'
          onOpenChange={setSearchOpen}
          open={searchOpen}
        >
          <DrawerTrigger asChild>
            <button
              aria-current={isSearchActive ? "page" : undefined}
              aria-haspopup='dialog'
              className={cn(
                "flex flex-col items-center justify-center gap-1 py-2 text-muted-foreground text-xs transition-colors",
                isSearchActive && "text-primary"
              )}
              type='button'
            >
              <Search className='h-5 w-5' />
              <span>Pesquisa</span>
            </button>
          </DrawerTrigger>

          <DrawerContent className='flex h-[85vh] flex-col'>
            <DrawerHeader className='flex items-center justify-between'>
              <DrawerTitle>Busca</DrawerTitle>
              <DrawerClose asChild>
                <button
                  aria-label='Fechar'
                  className='rounded-md px-2 py-1 text-muted-foreground hover:text-foreground'
                  type='button'
                >
                  Fechar
                </button>
              </DrawerClose>
            </DrawerHeader>

            <div className='flex min-h-0 flex-1 flex-col gap-4 px-4 pb-6'>
              <SearchProducts autoFocus={searchOpen} variant='drawer' />
            </div>
          </DrawerContent>
        </Drawer>
      </div>
    </nav>
  )
}
